var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", [_c("h1", [_vm._v(_vm._s(_vm.$t("kelaBatch.title")))])]),
          _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.loading },
                  on: { click: _vm.refresh }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-refresh")
                  ]),
                  _vm._v(" " + _vm._s(_vm.$t("kelaBatch.refresh")) + " ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("kela-batch-summary", {
                on: { "filter-by-status": _vm.filterByStatus }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("kela-batch-table", {
                on: { "select-batch": _vm.selectBatch }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.selectedBatch
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { ref: "detailPanel", attrs: { cols: "12" } },
                [
                  _c("kela-batch-detail-panel", {
                    attrs: { batch: _vm.selectedBatch },
                    on: { close: _vm.closeDetails }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: { color: "error", timeout: "6000" },
          model: {
            value: _vm.errorSnackbar,
            callback: function($$v) {
              _vm.errorSnackbar = $$v
            },
            expression: "errorSnackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.error) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }